import QRCode from 'qrcode';

/** Offline QR as PNG data-URL (no third-party CDN). */
export async function qrDataUrl(text, size = 200) {
  if (!text) return '';
  return QRCode.toDataURL(String(text), {
    width: size,
    margin: 2,
    color: { dark: '#0f172a', light: '#ffffff' },
  });
}
